/**
 * select-clipboard-modal.js
 *
 * Modal which allows user to view and filter a list of their clipboards. They
 * may also change a clip's clipboard if an origin clipboard is provided.
 *
 */

(function (ss) {
  var utils = ss.utils,
    api = utils.imports('clips.api'),
    ClipboardsList = utils.imports('clips.ClipboardsList'),
    EVENT_NAMESPACE = '.selectclipboard',
    FORM_TYPE_COPY = 'copy',
    FORM_TYPE_MOVE = 'move',

    selectors = {
      body: 'body',
      loader: '.loading',
      modalTitle: '.modal-title',
      modalContent: '.modal-content',
      allClipboardsHeader: '.all-clipboards-header',
      defaultClipboardTitle: '.default-clipboard-title',
      defaultClipboardPanel: '.default-clipboard-panel',
      defaultClipboardList: '.existing-clipboard-list',
      clipboardListContainer: '.clipboard-list-container',
      createNewClipboard: '.clipboard-create-new'
    },

    events = {
      // Triggered global bus events
      clipCopied: 'clip:copied',
      clipMoved: 'clip:moved',
      clipboardSelected: 'clipboard:selected',
       // Modal Events
       click: 'click' + EVENT_NAMESPACE,
       beforeModalOpen: 'open.fndtn.reveal' + EVENT_NAMESPACE,
       afterModalOpen: 'opened.fndtn.reveal' + EVENT_NAMESPACE,
       afterModalClose: 'closed.fndtn.reveal' + EVENT_NAMESPACE
    },

    templates = {
      clipboardListItem: 'templates.clipping.clipboards-list-item',
      clipboardListItemDefault: 'templates.clipping.clipboards-list-item-default'
    },

    storageKeys = {
      defaultClipboard: 'slideshare.clips.defaultClipboard.' + ss.user.id
    },

    i18n = {
      select: utils.i18n('select'),
      selected: utils.i18n('selected'),
      select_new_clipboard: utils.i18n('clipping.select_clipboard_modal.select_new_clipboard'),
      select_another_clipboard: utils.i18n('clipping.select_clipboard_modal.select_another_clipboard')
    },

    DEFAULT_CONFIG = {
      el: null,
      clipboards: [],
      defaultClipboard: null,
      actionType: FORM_TYPE_COPY
    };

  /**
   * Creates a new SelectClipboardModal instance with optional configuration.
   * @param options {Object} Configurable options for instance.
   * @param option.el {String}
   * @param option.clipboards {Array}
   * @param option.defaultClipboard {Array} The
   * @constructor
   */
  function SelectClipboardModal(options) {
    this.api = api;
    this.config = $.extend(true, {}, DEFAULT_CONFIG, options);
    this.$el = $(this.config.el);

    if (!this.$el.length) {
      console.error('Unable to initialize SelectClipboardModal');
    } else {
      this.clipboards = this.config.clipboards || [];
      this.clips = ss.slideshow.clips || {};
      this.defaultClipboard = this.config.defaultClipboard || {};
      this.currentClip = null;

      this.templates = {
        clipboardListItem: utils.imports(templates.clipboardListItem),
        clipboardListItemDefault: utils.imports(templates.clipboardListItemDefault)
      };

      this.clipboardsList = new ClipboardsList({
        el: this.config.el
      });

      this.config.actionType = this.config.actionType.toLowerCase();
      this._init();
    }
  }

  /**
   * Initialize SelectClipboardModal and attach events
   */
  SelectClipboardModal.prototype._init = function() {
    this.$loader = this.$el.find(selectors.loader);
    this.$modalTitle = this.$el.find(selectors.modalTitle);
    this.$modalContent = this.$el.find(selectors.modalContent);
    this.$defaultClipboardPanel = this.$el.find(selectors.defaultClipboardPanel);

    this._attachEventListeners();
  };

  /**
   * Attach event listeners
   */
  SelectClipboardModal.prototype._attachEventListeners = function() {
    this.clipboardsList.on(events.clipboardSelected, this._onClipboardSelected.bind(this));

    this.$el.on(events.click, selectors.createNewClipboard, this._onCreateNewClipboardClick.bind(this));
    this.$el.on(events.beforeModalOpen, this._onBeforeModalOpen.bind(this));
    this.$el.on(events.afterModalClose, this._onAfterModalClose.bind(this));
  };

  /**
   * Detach event listeners based on namespace
   */
  SelectClipboardModal.prototype._detachEventListeners = function() {
    $(document).off(EVENT_NAMESPACE);
    this.$el.off(EVENT_NAMESPACE);
  };

  /**
   * Triggered by a clipboardSelected event from ClipboardsList
   * Either copy or move the clip
   */
  SelectClipboardModal.prototype._onClipboardSelected = function(e, clipboard) {
    if (this.config.actionType === FORM_TYPE_COPY) {
      this.addClipToClipboard(this.currentClip, clipboard)
        .then(function(data) {
            if (!data.clip.alreadyInClipboard) {
              this.setUserDefaultClipboard(clipboard.id);
              $(document).trigger(events.clipCopied, data);
            }
            this.close();
          }.bind(this))

        .fail(function(xhr, status, error) {
          if (xhr) {
            console.error('Error while clipping. ' + xhr.statusText);
          }
        });
    }

    if (this.config.actionType == FORM_TYPE_MOVE) {
      this.moveClip(this.defaultClipboard, clipboard)
        .then(function(data) {
          $(document).trigger(events.clipMoved, data);
          this.close();
        }.bind(this))
        .fail(function(xhr, status, error) {
          // TODO: Surface error in UI
          if (xhr) {
            console.error('Error while moving clip. ' + xhr.statusText);
          }
        });
    }
  };


  /**
   * Show the create clipboard modal and give it an appropriate callback
   * on close of the modal
   */
  SelectClipboardModal.prototype._onCreateNewClipboardClick = function() {
    var createModal = new ss.Clipboards.EditModal({
        el: '#clipboard-create-modal',
        type: 'create',
          // NOTE: Move arguments to object hash?
        onClose: function(status, response) {
          var clipboard;

          if (status === 'created' && response && response.clipboard) {
            // Trigger event to either copy or move the clip to newly created clipboard
            this.clipboardsList._$events.trigger(events.clipboardSelected, response.clipboard);
          } else {
            this._attachEventListeners();
            this.clipboardsList._attachEventListeners();
            this.open({clip: this.currentClip});
          }
        }.bind(this)
    });
    createModal.open();
  };

  /**
   * Setup the modal before it opens depending on if it is a move or copy modal
   */
  SelectClipboardModal.prototype._onBeforeModalOpen = function() {
    var isActionTypeCopy = this.config.actionType === FORM_TYPE_COPY,
        modalTitle = isActionTypeCopy ? i18n.select_another_clipboard : i18n.select_new_clipboard;

    // Don't show content until it's fetched
    this.$modalContent.hide();
    this.$loader.show();

    // Title may change depending on context of action being performed
    if (modalTitle) {
      this.updateModalTitle(modalTitle);
    }

    // Show the "looks like you've clipped this slide to ... already" message
    if (isActionTypeCopy) {
      $(selectors.defaultClipboardTitle).text(this.defaultClipboard.title);
      this.$defaultClipboardPanel.show();
    }

    // Temporarily disable page scrolling
    $(selectors.body).css('overflow-y', 'hidden');
  };

  /**
   * Actions to perform after modal is closed
   */
  SelectClipboardModal.prototype._onAfterModalClose = function() {
    this.reset();
  };

  /**
   * Update the modal title
   */
  SelectClipboardModal.prototype.updateModalTitle = function(title) {
    this.$modalTitle.text(title);
  };

  /**
   * Show the default clipboard. Used for when modal is in "move" mode
   */
  SelectClipboardModal.prototype.showDefaultClipboardUI = function() {
    if (this.templates.clipboardListItemDefault && this.config.actionType === FORM_TYPE_MOVE) {
      $(selectors.defaultClipboardList).empty().append(
        $(this.templates.clipboardListItemDefault($.extend(true, {}, {i18n: i18n}, this.defaultClipboard)))
      );
    }
  };

  /**
   * Loads the clipboards from the server
   * @param {Function} cb The callback that will be called when the clipboards are available
   */
  SelectClipboardModal.prototype.loadClipboards = function(callback) {
    this.api.clipboards()
      .then(function(clipboards) {
        callback(clipboards);
      }.bind(this), function() {
        console.log('Failed to load clipboards', arguments);
        callback();
      });
  };

  /**
   * Process some clipboards
   * If modal is in "move" mode, filter out the default clipboard
   */
  SelectClipboardModal.prototype._processClipboards = function(clipboards) {
    var clip = this.currentClip,
      clipboardsIdsWithClip = (clip && clip.clipboards) || [];

    return $.map(clipboards, function (clipboard) {
      // Update the default clipboard with most up to date data
      // In case the default clipboard was newly created and had no thumbnail
      if (clipboard.id === this.defaultClipboard.id
            && this.config.actionType == FORM_TYPE_MOVE) {
        this.defaultClipboard =  clipboard;
        // Remove the default clipboard from clipboards list
        // so that it is not shown twice
        return;
      }

      // Decorate with checkmarks
      clipboard.checked = false;

      if ($.inArray(clipboard.id, clipboardsIdsWithClip) > -1) {
        clipboard.checked = true;
      }

      return clipboard;
    }.bind(this));
  };

  /**
   * Sort clipboards so that ones that already contain the clip
   * appear first, then sorta alphabetically
   */
  SelectClipboardModal.prototype._sortedClipboardsBySelected = function(clipboardA, clipboardB) {
    // If both have are selected, do nothing.
    if (clipboardA.checked === clipboardB.checked) {
      return 0;
    }
    // If first clipboard is selected, place higher.
    if (clipboardA.checked) {
      return -1;
    }
    // If all else fails, assume clipboard not selected and place lower.
    return 1;
  };

  /**
   * Open the modal and load the clipboards
   */
  SelectClipboardModal.prototype.open = function(options) {
    var decoratedClipboards,
      sortedClipboards;

    this.currentClip = this.clips[options.clip && options.clip.position];
    this.$el.foundation('reveal', 'open');

    this.loadClipboards(function(clipboards) {
      if (!clipboards) {
        //this.showEmptyMessage();
      } else {
        const processedClipboards = this._processClipboards(clipboards);
        sortedClipboards = processedClipboards.sort(function(a, b) {
          return this._sortedClipboardsBySelected(a, b);
        }.bind(this));

        this.showDefaultClipboardUI();

        this.clipboardsList.update(processedClipboards);

        this.$loader.hide();
        this.$modalContent.show();
      }
    }.bind(this));
  };

  /**
   * Closes the modal dialog
   */
  SelectClipboardModal.prototype.close = function() {
    this.$el.foundation('reveal', 'close');
  };

  /**
   * Resets the modal dialog
   */
  SelectClipboardModal.prototype.reset = function() {
    this._detachEventListeners();
    this.clipboardsList._detachEventListeners();
    $(selectors.defaultClipboardList).empty();
    this.$defaultClipboardPanel.hide();

    $(selectors.clipboardListContainer).scrollTo(0);
    $(selectors.body).css('overflow-y', 'auto');
  };

  /**
   * Adds a new clip to a given clipboard
   * @public
   * @param {object} clip The clip being added
   * @param {object} toClipboard The clipboard to add clip to
   * @returns {jqXHR} The jqXHR object associated with the request
   */
   SelectClipboardModal.prototype.addClipToClipboard = function(clip, clipboard) {
    function updateClip(data){
      var clip = this.currentClip;

      if (clip) {
        clip.clipboards = clip.clipboards || [];
        if (clip.clipboards.indexOf(clipboard.id) === -1) {
          clip.clipboards.push(clipboard.id);
        }
      } else {
        data.clip.clipboards = [clipboard.id];
      }
      return data;
    }

    return this.api.addClipToClipboard(clipboard.id, clip)
     .then(function(data) {
        updateClip.call(this, data);

        return {
          clip: data.clip,
          clipboard: clipboard
        };
     }.bind(this), function(xhr, status, error) {
       console.error('Error adding to clipboard. ' + xhr.statusText);
     });
   };

   /**
    * Removes a clip from an individual clipboard
    * @public
    * @param {object} clip The clip being removed
    * @returns {jqXHR} The jqXHR object associated with the request
    */
    SelectClipboardModal.prototype.removeClipFromClipboard = function(clip, fromClipboard) {
      var fromClipboardId = fromClipboard.id;

      function updateClip(){
        var clip = this.currentClip,
            removeIndex;

        if (clip) {
          clip.clipboards = clip.clipboards || [];
          removeIndex = clip.clipboards.indexOf(fromClipboardId);
          if ( removeIndex > -1) {
            clip.clipboards.splice(removeIndex, 1);
          }
        }
      }

    return this.api.deleteClipFromClipboard(fromClipboardId, clip.id)
      .then(function(response) {
        updateClip.call(this);
        return response;
      }.bind(this), function(xhr, status, error) {
        console.error('Error removing clip from clipboard. ' + xhr.statusText);
      }.bind(this));
    };

  /**
    * Moves a clip from one clipboard to another, removing itself from the old
    * clipboard and adding itself to the new clipboard
    * @public
    * @param {object} clip The clip being moved
    * @param {object} toClipboard The clipboard to add clip to
    * @returns {jqXHR} The jqXHR object associated with the request
    */
    SelectClipboardModal.prototype.moveClip = function(fromClipboard, toClipboard) {
      var currentClip = this.currentClip;

      // 1. Add clip to new clipboard
      return this.addClipToClipboard(currentClip, toClipboard)
        .then(function() {
          // 2. Remove clip from old clipboard
          return this.removeClipFromClipboard(currentClip, fromClipboard);
        }.bind(this))

      .then(function() {
        // 3. Update default clipboard
        this.setUserDefaultClipboard(toClipboard.id);

        return {
          clip: currentClip,
          fromClipboard: fromClipboard,
          toClipboard: toClipboard
        };
      }.bind(this));
    };

  /**
   * Set the user's default clipboard in local storage
   */
   SelectClipboardModal.prototype.setUserDefaultClipboard = function(clipboardId) {
     if (window.localStorage) {
       window.localStorage.setItem(storageKeys.defaultClipboard, clipboardId);
     }
   };

  utils.exports('SelectClipboardModal', SelectClipboardModal);

}(window.slideshare_object));
